const e=async(e,t)=>{await e.delete(`/roles/${t}`)};export{e as deleteRole};
//# sourceMappingURL=delete-role.mjs.map